import { API } from '@Providers';
import type { IntakeType } from '@IntakeModule';

interface AddIntakeAnimalToCartRequest {
  animals: any[]; // TODO :: AF-888 - Create People schema
  cart_type: 'intake';
  form_id: string;
  outcome_title: string;
  outcome_type: IntakeType;
  people?: any; // TODO :: AF-887 - Create People schema
  resetCart: boolean;
}

export default async function (payload: AddIntakeAnimalToCartRequest) {
  const endpoint = '/api/shelter/animal-intake/add-to-cart';

  return API({ endpoint, method: 'post', payload });
}
